__turbopack_context__.v({
  "cards": "LegalSummary-module__GuqQpa__cards",
  "description": "LegalSummary-module__GuqQpa__description",
  "facts": "LegalSummary-module__GuqQpa__facts",
  "icon": "LegalSummary-module__GuqQpa__icon",
  "item": "LegalSummary-module__GuqQpa__item",
  "label": "LegalSummary-module__GuqQpa__label",
  "linkFill": "LegalSummary-module__GuqQpa__linkFill",
  "linkItem": "LegalSummary-module__GuqQpa__linkItem",
  "links": "LegalSummary-module__GuqQpa__links",
  "list": "LegalSummary-module__GuqQpa__list",
  "summary": "LegalSummary-module__GuqQpa__summary",
  "text": "LegalSummary-module__GuqQpa__text",
  "value": "LegalSummary-module__GuqQpa__value",
});
